const zh_CN = {
    info: {
        title: "八吨按钮",
        info: "信息",
        null: "空",
        audioStaff: "素材提供: Notorius Chase",
        toGithub: "请在Github参与翻译、增补音频或提出建议",
        notOfficial: "本站为爱好者作品",
        overlapTips: "重叠播放无法暂停，而且会创建大量线程，玩够了最好刷新一下"
    },
    action: {
        toggleNavbar: "切换导航栏",
        close: "关闭",
        copy: "复制",
        control: "操作控制",
        stopvoice: "停止",
        randomplay: "帮我选一个",
        overlap: "允许声音重叠",
        autoplay: "播放不要停下来",
        playing: "正在播放：",
        noplay: "暂无播放"
    },
    lang: {
        'zh-CN': "简体中文",
        'en-US': "English",
        'ja-JP': "日本語"
    }
}
export default zh_CN;
